import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { getBooking } from '../../redux/actions/bookings';
import {
  IconButton,
  RouteWrapper,
  HeadingSection,
  BookingReturnForm,
  Section,
  BookingSidebar,
} from '../../components';

interface Props {
  match: any;
  dispatch: Function;
}

interface State {
  id: number;
  booking: any;
  errorMessage: string | boolean;
  isLoading: boolean;
  isReady: boolean;
}

class BookingReturn extends React.Component<Props, State> {
  state = {
    id: this.props.match.params.id,
    booking: undefined,
    errorMessage: false,
    isLoading: false,
    isReady: false,
  };

  async componentDidMount() {
    this.setState({ isLoading: true });
    const { error, data } = await this.props.dispatch(
      getBooking(this.state.id),
    );
    if (error) {
      this.setState({
        errorMessage: error,
        isLoading: false,
      });
    } else {
      this.setState({
        booking: data,
        isLoading: false,
        isReady: true,
      });
    }
  }

  render() {
    let breadcrumbs = [];
    if (this.state.booking) {
      breadcrumbs = [
        {
          link: `/bookings/status/${this.state.booking.status}`,
          text: `Bookings`,
        },
        {
          link: `/bookings/${this.state.id}`,
          text: this.state.booking.invoiceId,
        },
        {
          link: `/bookings/${this.state.id}/return`,
          text: 'Return Booking',
        },
      ];
    }
    return (
      <RouteWrapper
        requireAuth
        title="Return Booking"
        requirePermission="MANAGE_BOOKINGS"
        error={this.state.errorMessage}
        loading={this.state.isLoading}
        ready={this.state.isReady}
        breadcrumbs={breadcrumbs}
      >
        {this.state.booking && (
          <>
            <HeadingSection
              title={`Return Booking for ${this.state.booking.contact_name}`}
              controls={[
                <IconButton
                  icon="undo"
                  className="is-default is-pulled-right"
                  handleClick={() => {
                    this.props.dispatch(goBack());
                  }}
                  key="return"
                >
                  Return
                </IconButton>,
              ]}
            />
            <Section>
              <div className="columns is-multiline">
                <div className="column is-12-desktop is-7-widescreen">
                  <BookingReturnForm
                    id={this.state.id}
                    handleSubmit={() => this.props.dispatch(goBack())}
                    mileageBefore={this.state.booking.mileage_before}
                  />
                </div>
                <div className="column is-12-desktop is-5-widescreen">
                  <BookingSidebar booking={this.state.booking} />
                </div>
              </div>
            </Section>
          </>
        )}
      </RouteWrapper>
    );
  }
}

export default connect()(BookingReturn);
